<template>
  <div class="container">
    <div class="d-flex justify-content-center flex-wrap mb-1 px-2">
      <button
        v-for="item in facilities"
        :key="item.name"
        class="btn btn-custom-facilities ms-3 mb-2"
        @click="setVideo(item)"
      >
        <span>{{ lang == 'en' ? item.en_name : item.name }}</span>
        <i v-show="active.url_video === item.url_video" class="block fa fa-chevron-down" aria-hidden="true"></i>
      </button>
    </div>
    <div class="d-flex justify-content-center container-video-facilities">
      <Transition name="fade">
        <vue3-video-player
          v-show="showVideo"
          :src="active.url_video"
          title=""
          :controls="false"
          :cover="active.img"
          :view-core="viewCore.bind(null, 'videoMaster')"
          autoplay
        ></vue3-video-player>
      </Transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Facilities',
  props: {
    lang: {
      type: String,
      default: 'es',
      required: false,
    },
  },

  data() {
    return {
      showVideo: true,
      players: {},
      active: {
        name: 'Viaducto y RoRo',
        img: '/video/back1.png',
        url_video: '/video/viaducto_roro.mp4',
      },
      facilities: [
        {
          name: 'Viaducto y RoRo',
          en_name: 'Viaduct and Ro-Ro',
          img: '/video/back1.png',
          url_video: '/video/viaducto_roro.mp4',
        },
        // {
        //   name: 'Gruas móviles',
        //   en_name: 'Mobile Cranes',
        //   img: '/video/back1.png',
        //   url_video: '/video/gruas_moviles.mp4',
        // },
        {
          name: 'Gruas STS',
          en_name: 'STS Cranes',
          img: '/video/back1.png',
          url_video: '/video/gruas_sts.mp4',
        },
        {
          name: 'Patio de contenedores',
          en_name: 'Patio de contenedores',
          img: '/video/back2.png',
          url_video: '/video/patio_contenedores.mp4',
        },
        {
          name: 'Graneles, Inspeccion Aduanera',
          en_name: 'Graneles, Inspeccion Aduanera',
          img: '/video/back2.png',
          url_video: '/video/graneles_inspeccion_aduanera.mp4',
        },
        {
          name: 'Crossdocking',
          en_name: 'Crossdocking',
          img: '/video/back2.png',
          url_video: '/video/crossdoking.mp4',
        },
      ],
    }
  },
  methods: {
    setVideo(item) {
      this.active = item
      this.play('videoMaster')
    },
    viewCore(id, player) {
      console.log(id, player)
      this.players[id] = player
    },
    play(id) {
      console.log('custom play: id =', id)
      this.players && this.players[id] && this.players[id].play()
    },
  },
}
</script>
